import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faGlobe } from "@fortawesome/pro-solid-svg-icons/faGlobe";
import { faQuestion } from "@fortawesome/pro-solid-svg-icons/faQuestion";
import { faStickyNote } from "@fortawesome/pro-solid-svg-icons/faStickyNote";
import { faUserGraduate } from "@fortawesome/pro-solid-svg-icons/faUserGraduate";
import { faUserLock } from "@fortawesome/pro-solid-svg-icons/faUserLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PublicationType } from "models/ApiEnums";
import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    publicationType: PublicationType;
    isPublic: boolean;
    size?: SizeProp;
}

const PublicationIcon: React.FC<IProps> = (props) => {
    const { publicationType, isPublic, size } = props;
    const { t } = useTranslation("sys");

    switch (publicationType) {
        case PublicationType.Post:
            return <FontAwesomeIcon fixedWidth icon={faStickyNote} size={size} title={t("PublicationType.Post")} />;
        case PublicationType.Question:
            return <FontAwesomeIcon fixedWidth icon={faQuestion} size={size} title={t("PublicationType.Question")} />;
        case PublicationType.List:
            return <FontAwesomeIcon fixedWidth icon={isPublic ? faGlobe : faUserLock} size={size} title={t("PublicationType.List")} />;
        case PublicationType.Course:
            return <FontAwesomeIcon fixedWidth icon={faUserGraduate} size={size} title={t("PublicationType.Course")} />;
    }
    return null;
};

export default PublicationIcon;
